import Api from "~/service/Api";

class YoutubeRepository {
  getUserInfo() {
    return Api.get("/you-tube/authentication/me");
  }

  removeAccountLink(youtubeAuthenticationId) {
    return Api.delete(`/you-tube/authentications/${youtubeAuthenticationId}`);
  }

  authorizationUrls() {
    return Api.post("/you-tube/authorization-urls");
  }

  fetchAccountData(youtubeAuthenticationId) {
    return Api.put(`/you-tube/authentication/channel-lookup/${youtubeAuthenticationId}`);
  }

  findUploadJob(tourId) {
    return Api.get(`/jq-store/you-tube-upload-jobs?tourId=${tourId}`);
  }

  createUploadJob(tourId) {
    return Api.post("/jq-store/you-tube-upload-jobs", { tourId });
  }

  getUploadJobStatus(jobId) {
    return Api.get(`/jq-store/you-tube-upload-jobs/${jobId}`);
  }
}

export default YoutubeRepository;
